import { IDataTableOptionalProps } from "../../DataTable/common/defaults";
import moment from "moment";

export const formTableColumns = [
    {
        title:"Edit Form",
        data:'_id'
    },
    {
        title:"Name",
        data:"title"
    },
    {
        title:"Last Modified",
        data:(row,type,set,meta) => {
            return moment(row.modified).format('dddd, MMMM Do, YYYY');
        }
    }
]

export const formTableOptions:IDataTableOptionalProps = {
    showSelectInfo: false,
    lengthChange:false,
    order:[[1,'asc']]
}


